export default class Teaser {
    private titles = document.querySelectorAll('.custom-truncation') as any;

    constructor() {
        this.initialize();
    }

    private initialize(): void {
        this.truncate();
    }

    private truncate = (): void => {
        this.titles.forEach((titleElement) => {
            const titleText = titleElement.textContent.trim();
            const words = titleText.split(' ');
            const maxWords = 5;
            const maxCharacters = 40;

            let truncatedText = '';

            if (words.length > maxWords) {
                truncatedText = words.slice(0, maxWords).join(' ') + '...';
            } else if (titleText.length > maxCharacters) {
                truncatedText = titleText.substring(0, maxCharacters) + '...';
            }

            titleElement.textContent = truncatedText;
            titleElement.title = truncatedText;
        });
    }
}
